export default {
  default_program_name: 'Kanta-asiakasohjelma',
  message:
    'Liity <highlight>{{name}}</highlight>-ohjelmaan — ansaitse {{reward}} jokaista {{spend}} kohden & avaa ilmaisia menutuotteita!',
  buttons: {
    join_now: 'Liity nyt',
  },
};
